export default __webpack_public_path__ + "11c74143a5320ccc10922f0cd55e6f9a.svg";